import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-hd gfu-hd--h2 _flex _gap-1 _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("h3", _hoisted_1, [
    ($props.iconName)
      ? (_openBlock(), _createBlock(_component_base_icon, {
          key: 0,
          name: $props.iconName,
          "icon-namespace": $props.iconNamespace,
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["name", "icon-namespace"]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}